import React from "react";
import "./whatGPT3.css";
import { Feature } from "../../components";

const WhatGPT3 = () => (
  <div className="gpt3__whatgpt3 section__margin" id="wgpt3">
    <div className="gpt3__whatgpt3-feature animated-from-top">
      <Feature
        title="What is Phone-T Technology"
        text="We hold the opinion that friends, like messages, bring delight. The entire front is a canvas where the plate resonates with the sound of 'oh' and 'ought.' No defective elements, nor a residence unconvinced. The connection has made its mark, turning apartments into a boisterous haven. At the jointure, ladyship insists on humanity. A friendly bachelor's entrance is an invitation to be on board."
      />
    </div>

    <div className="gpt3__whatgpt3-heading">
      <h1 className="gradient__text">The possibilities are beyond your imagination</h1>
      <p>Explore the Phone-T Hub</p>
    </div>

    <div className="gpt3__whatgpt3-container animated-from-bottom">
      <Feature
        title="Phone-T Features"
        text="Explore the features that make Phone-T stand out. Our opinions, friends, and messages converge to create delightful experiences."
      />
      <Feature
        title="Phone-T Knowledge Base"
        text="At the jointure, ladyship insists on humanity. A friendly bachelor's entrance welcomes you to delve into a knowledge base enriched with insights."
      />
      <Feature
        title="Phone-T Education"
        text="Embark on a journey of education with Phone-T. At the jointure, ladyship emphasizes humanity, and a friendly bachelor's entrance guides you"
      />
    </div>
  </div>
);

export default WhatGPT3;
